import Vue from 'vue';
import VueRouter from 'vue-router';
import store from './store';
const routes = [{
    path: '/',
    component: () =>
        import ( /* webpackChunkName: "home" */ './pages/home/Index.vue'),
        meta: { title: '黑龙江新工科联盟' },
}, {

    path: '/newslist',
    component: () =>
        import ( /* webpackChunkName: "teacher" */ './pages/union/dynamic.vue'),
        meta: { title: '黑龙江新工科联盟' },
}, {
    path: '/newDetails',
    component: () =>
        import ( /* webpackChunkName: "newDetail" */ './pages/union/details.vue'),
}, {
    path: '/about',
    component: () =>
        import ( /* webpackChunkName: "teacher" */ './pages/about/Index.vue'),
        meta: { title: '黑龙江新工科联盟' },
}, {
    path: '/banner',
    component: () =>
        import ( /* webpackChunkName: "teacher" */ './pages/banner/Index.vue'),
        meta: { title: '黑龙江新工科联盟' },
}, {
    path: '/org',
    component: () =>
        import ( /* webpackChunkName: "teacher" */ './pages/org/Index.vue'),
        meta: { title: '黑龙江新工科联盟' },
}, ];
const router = new VueRouter({
    routes
});

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    const breadCrumb = to.matched.filter(({ name }) => !!name).map(({ name, path }) => ({ name, path }));
    store.commit('setBreadCrumb', breadCrumb);
    next();
});
// router.afterEach((to,from,next)=>{
//     console.log(store.getters.count)
//     next();
// });
Vue.use(VueRouter);
export default router;
export { routes }